import { setAlert } from '../alert';
import { SET_PROPERTY_FIELDS } from '../../types';

/**
 * @name    updateEnvironmental
 * @param   event
 * @returns {function(...[*]=)}
 */
export const updateEnvironmental = (event) => async(dispatch, getState) => {
    try {
        const { properties: { propertyFields } } = getState();

        //  DESC: Update Property value and re-calculate data
        const newPropertyFields = {
            ...propertyFields,
            [event.target.name]: event.target.value,
            environmental_flag: 'N',
            environmental_codes_LDBP: 0
        };
        const { environmental_codes } = newPropertyFields;

        //  DESC: set `environmental_flag` to Yes if `environmental_codes` exists
        if (newPropertyFields.environmental_codes) {
            newPropertyFields.environmental_flag = 'Y';
            //  DESC: set `environmental_codes_LDBP` to true(1) if `environmental_codes` includes LDBP code
            if (newPropertyFields.environmental_codes.includes('LDBP')) {
                newPropertyFields.environmental_codes_LDBP = 1;
            }
        }

        await dispatch({
            type: SET_PROPERTY_FIELDS,
            payload: newPropertyFields
        });
    }
    catch (error) {
        dispatch(setAlert(error.message), 'error');
    }
};


export const environmentalHook = (event) => async(dispatch, getState) => {
    try {
        const { properties: { propertyFields } } = getState();

        //  DESC: Update Property value and re-calculate data
        const newPropertyFields = {
            ...propertyFields,
            [event.target.name]: event.target.value,
        };
        const { environmental_codes } = newPropertyFields;

        // DESC: Set LDBP if criteria is met
        let codes = environmental_codes 
            ? environmental_codes.split(',')
            : [];

        /*
         * Property Type
		  App\CodesDescriptions {#19438
			id: 18,
			code: "1",
			description: "SFR/SFD (1-4)",
		  },
		  App\CodesDescriptions {#19442
			id: 19,
			code: "2",
			description: "Multi-Family (5+)",
		  },
		  App\CodesDescriptions {#19441
			id: 20,
			code: "3",
			description: "Commercial",
		  },
         */

        /*
         * Property Sub Type
            App\CodesDescriptions {#19398
            id: 34,
            code: "12",
            description: "Mixed-Use",
            },
         */
        let hasValidType = [18,19].includes( // SFR + Multi-Family
            parseInt(newPropertyFields.type_primary)
        ) || newPropertyFields.type_primary == 20 // Commercial
            && newPropertyFields.type_secondary == 34; // mixed-use
        if (hasValidType
			&& newPropertyFields.year_built != null
			&& newPropertyFields.year_built <= 1978
            && ! codes.includes('LDBP')) {
            codes.push('LDBP');
            newPropertyFields.environmental_codes = codes.join(',');
        }

        await dispatch({
            type: SET_PROPERTY_FIELDS,
            payload: newPropertyFields
        });

        dispatch(updateEnvironmental(event));
    }
    catch (error) {
        dispatch(setAlert(error.message), 'error');
    }
};
